import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { IAggregate, ICardData, ICardAction, ActionType } from "@tylertech/tyler-api-types";

import { DetailDialogComponent, DetailDialogData } from "../components";
import { IAggregateActionHandler, ActionReturn } from "../interfaces";
import { AggregateActionResult, AggregateHelperService, } from "../services";

@Injectable()
export class DialogActionHandler implements IAggregateActionHandler
{
    private $aggregateHelperService = inject(AggregateHelperService);
    private readonly matDialog = inject(MatDialog);


    predicate(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return action.actionType === ActionType.Dialog;
    }

    execute(aggregate: IAggregate, cardData: ICardData, action: ICardAction): Promise<AggregateActionResult>
    {
        const passedActions = cardData.CardActions.filter(v => v.actionType !== ActionType.Dialog);

        // const dialogOptions = new DetailDialogOptions(action.Model, action.content, null, passedActions);
        // return Promise.resolve(this.$mdDialog.show(dialogOptions))
        const dialogConfig: MatDialogConfig<DetailDialogData> = {
            data: {
                model: action.Model,
                detailUrl: action.content,
                color: undefined,
                cardActions: passedActions,
            }
        };
        const dialogRef = this.matDialog.open<DetailDialogComponent, DetailDialogData, ICardAction | undefined>(DetailDialogComponent, dialogConfig);
        return dialogRef.afterClosed()
            .toPromise()
            .then((dialogResult: ICardAction) =>
            {
                if (dialogResult)
                {
                    // TODO this will cause a runtime Circular Dep, figure it out
                    return this.$aggregateHelperService.performServerCardAction(aggregate, cardData, dialogResult)
                        .then(() =>
                        {
                            return <ActionReturn>{
                                action: dialogResult,
                                success: true,
                            };
                        });
                }
                else
                {
                    return true;
                }
            });
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
